<template>
    <div>
        <div class="org-tree-layout">
            <swb-popover-org-tree :showMgmt="true" :mgmtOnlyOrg="true" :showIncludeSubComs="false" :initIncludeSubComs="false" :bizDepart="true" @notity-change="checkComCatChange($event)"></swb-popover-org-tree>
        </div>
        <div class="simple-form" v-if="channelCode == 'bizParamComn'">
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">开启岗位组织</label>
                </div>
                <div class="form-value">
                    <el-radio-group v-model="comInfo.postOrgEnabled">
                        <el-radio class="radio" :label=false>否</el-radio>
                        <el-radio class="radio" :label=true>是</el-radio>
                    </el-radio-group>
                </div>
            </div>
            <div class="form-group center" style="display: none;">
                <div class="form-label">
                    <label class="required">开启岗位地区</label>
                </div>
                <div class="form-value">
                    <el-radio-group v-model="comInfo.postRegionEnabled">
                        <el-radio class="radio" :label=false>否</el-radio>
                        <el-radio class="radio" :label=true>是</el-radio>
                    </el-radio-group>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">开启岗位商品分类</label>
                </div>
                <div class="form-value">
                    <el-radio-group v-model="comInfo.postGoodsCatEnabled" :disabled="comInfo.postDevcGrpEnabled">
                        <el-radio class="radio" :label=false>否</el-radio>
                        <el-radio class="radio" :label=true>是</el-radio>
                    </el-radio-group>
                    <div class="input-tip error">【岗位商品分类】与【设备分类分组】只能开启一个</div>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">开启设备分类分组</label>
                </div>
                <div class="form-value">
                    <el-radio-group v-model="comInfo.postDevcGrpEnabled" :disabled="comInfo.postGoodsCatEnabled">
                        <el-radio class="radio" :label=false>否</el-radio>
                        <el-radio class="radio" :label=true>是</el-radio>
                    </el-radio-group>
                </div>
            </div>
            <!--<div class="form-group center">-->
            <!--<div class="form-label">-->
            <!--<label class="required">开启岗位服务分类</label>-->
            <!--</div>-->
            <!--<div class="form-value">-->
            <!--<el-radio-group v-model="comInfo.postServcCatEnabled">-->
            <!--<el-radio class="radio" :label=false>否</el-radio>-->
            <!--<el-radio class="radio" :label=true>是</el-radio>-->
            <!--</el-radio-group>-->
            <!--</div>-->
            <!--</div>-->
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">开启岗位管理区域</label>
                </div>
                <div class="form-value">
                    <el-radio-group v-model="comInfo.postMgmtAreaEnabled">
                        <el-radio class="radio" :label=false>否</el-radio>
                        <el-radio class="radio" :label=true>是</el-radio>
                    </el-radio-group>
                </div>
            </div>
            <div class="form-group center" v-if="!comInfo.shopFlag">
                <div class="form-label">
                    <label class="required">开启下级机构标签</label>
                </div>
                <div class="form-value">
                    <el-radio-group v-model="comInfo.postSubShopTagFilterEnabled">
                        <el-radio class="radio" :label=false>否</el-radio>
                        <el-radio class="radio" :label=true>是</el-radio>
                    </el-radio-group>
                </div>
            </div>
        </div>

        <div class="simple-form" v-if="channelCode == 'bizParamRepair'">
            <div class="form-group center">
                <div class="form-label">
                    <label>区域报修人</label>
                </div>
                <div class="form-value">
                    <el-input class="width-1-5x bottom-line" :disabled="true" v-model="comInfo.patrolGuardStaffName"></el-input>
                    <i class="icon iconfont icon-chazhaobiaodanliebiao relation-icon" @click="selectStaffName"></i>
                    <i class="input-deletable" style="right: 18px;" v-if="comInfo.patrolGuardStaffId" @click="deleteStaffName">×</i>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">小助手是否可报修</label>
                </div>
                <div class="form-value">
                    <el-radio-group v-model="comInfo.assistRepairRequestAllowed">
                        <el-radio class="radio" :label=false>否</el-radio>
                        <el-radio class="radio" :label=true>是</el-radio>
                    </el-radio-group>
                </div>
            </div>
            <div class="form-group center" v-if="comInfo.assistRepairRequestAllowed">
                <div class="form-label">
                    <label class="required">默认提报人</label>
                </div>
                <div class="form-value">
                    <el-input class="width-1-5x bottom-line" :disabled="true" v-model="comInfo.defRepairStaffName"></el-input>
                    <i class="icon iconfont icon-chazhaobiaodanliebiao relation-icon" @click="selectDefStaffName"></i>
                    <i class="input-deletable" style="right: 18px;" v-if="comInfo.defRepairStaffId" @click="deleteDefStaffName">×</i>
                </div>
            </div>
        </div>
        <div class="simple-form">
            <div class="form-group">
                <div class="form-label"></div>
                <div class="form-value">
                    <button class="swb-btn swb-btn-small" id="saveBtn" @click="submitForm();">保存</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'
    import appConf from '../../app.conf';
    import { openComStaffMainForSelectDlg, openComStaffComnSelectDlg } from '../orgStruct/selectDlg'

    import userApi from '../../api/user'
    import retailerApi from '../../api/retailer'

    import SwbPopoverOrgTree from '../orgStruct/PopoverOrgTree';
    Vue.regist(SwbPopoverOrgTree);

    export default {
        name: 'swb-org-biz-param-list',
        avlScopes: 'retailer',
        desc: '机构级业务参数设置',
        props: {
            channelCode: {
                default: null
            }
        },
        data: function () {
            return {
                shopQrCode: null,
                retailerShopTagList: [],
                comInfo: {}
            }
        },
        created: function () {
            //
            this.getUserInfoByContext();
            this.getShopTag();
        },
        methods: {
            getUserInfoByContext: function () {
                let self = this;
                userApi.getUserInfoByContext(null, function (result, jqXhr) {
                    if(result.type == 'info') {
                        let userContext = result.data;
                        let scopeEntity = userContext.scopeEntity;
                        //
                        self.getComInfo(scopeEntity.comId);
                    } else {
                        self.$message.error(result.message);
                    }
                });
            },
            checkComCatChange: function (eventDate) {
                //
                this.getComInfo(eventDate.id);
            },
            getComInfo: function (comId) {
                let self = this;
                let postData = {
                    comId: comId
                };
                let theLoad = MsgBox.loading();
                retailerApi.getRetailerCom(postData, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        let comInfo = result.data;
                        self.comInfo = comInfo;
                        //
                        let shopQrCodeObj = {
                            type: 'swb.info.shop',
                            merchantId: comInfo.merchantId,
                            id: comInfo.id
                        };
                        let target = JSON.encode(shopQrCodeObj);
                        self.shopQrCode = appConf.makeQrCodeImageUrl(target);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getShopTag: function () {
                let self = this;
                let loading = MsgBox.loading();
                retailerApi.getRetailerShopTagList({}, function (result) {
                    loading.hide();
                    if(result.type == "info") {
                        self.retailerShopTagList = result.data || [];
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 页签切换
            changShopTag: function (item) {
                let self = this;
                let comInfo = self.comInfo;
                comInfo.shopTagFlag = true;
                if(comInfo.tagId == item.id) {
                    comInfo.tagId = null;
                    comInfo.tagName = null;
                } else {
                    comInfo.tagId = item.id;
                    comInfo.tagName = item.name;
                }
                self.comInfo = Utils.merge({}, self.comInfo);
            },
            // 区域报修人
            selectStaffName: function () {
                let self = this;
                let dlgConfig = {
                    isSelectThisLevel: false,
                    title: "公司员工-选择",
                };
                let comInfo = self.comInfo;
                openComStaffMainForSelectDlg(dlgConfig, function (stuff, theDlg) {
                    if(stuff.comId == comInfo.id) {
                        MsgBox.warning("不能选择本公司人员");
                    } else {
                        comInfo.patrolGuardStaffName = stuff.name;
                        comInfo.patrolGuardStaffId = stuff.id;
                        self.comInfo = Utils.merge({}, comInfo);
                        theDlg.close();
                    }
                })
            },
            deleteStaffName: function () {
                let self = this;
                let comInfo = self.comInfo;
                comInfo.patrolGuardStaffName = null;
                comInfo.patrolGuardStaffId = null;
                comInfo.delPatrolGuard = true;
                self.comInfo = comInfo;
            },
            // 默认提报人设置
            selectDefStaffName: function () {
                let self = this;
                let comInfo = self.comInfo;
                openComStaffComnSelectDlg(comInfo.bizUnitId, true, function (stuff, theDlg) {
                    comInfo.defRepairStaffName = stuff.data.name;
                    comInfo.defRepairStaffId = stuff.data.id;
                    self.comInfo = Utils.merge({}, comInfo);
                    theDlg.close();
                })
            },
            deleteDefStaffName: function () {
                let self = this;
                let comInfo = self.comInfo;
                comInfo.defRepairStaffId = null;
                comInfo.defRepairStaffName = null;
                //
                self.comInfo = Utils.merge({}, comInfo);
            },
            shopFlagChange(){
                this.comInfo.postSubShopTagFilterEnabled = false;
            },
            // 查看大图-机构二维码
            showLogo: function (url) {
                Utils.setPageUrl(url, '_blank');
            },
            // 保存
            submitForm: function () {
                let self = this;
                self.comInfo.noFlag = true;
                let comInfo = self.comInfo;
                if(Utils.isTrue(comInfo.assistRepairRequestAllowed)) {
                    if(Utils.isNoB(comInfo.defRepairStaffId)) {
                        MsgBox.warning("请设置默认提报人");
                        return;
                    }
                } else {
                    comInfo.defRepairStaffId = null;
                    comInfo.defRepairStaffName = null;
                }
                retailerApi.updateRetailerComForBizParam(comInfo, function (result, jqXhr) {
                    self.loading = false;
                    if(result.type == 'info') {
                        //
                        self.$message.success('保存成功');
                    } else {
                        self.$message.warning(result.message);
                    }
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/bizParam/OrgBizParamList.vue